module.exports = __webpack_public_path__ + "static/clipboard-a09515a113b6123421d8203a93c759d4.gif";